module.exports = __webpack_public_path__ + "static/img/code3.70531e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/code3.jpg
// module id = M6Y+
// module chunks = 35